import { useQuery } from '@tanstack/react-query';
import { ReservedPersonalSchedule } from '#types/schedule';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Params {
  /** 조회할 날짜 (YYYY-MM-DD) */
  personalScheduleId?: string;
  isAdmin?: boolean;
}

/**
 * 코치 - 상세일정 가져오기
 * @link https://api-dev.fibud.kr/api#/%EC%88%98%EC%97%85%20-%20%EC%9D%BC%EC%A0%95/SchedulesController_findCoachSchedule
 * @param id
 * @param status
 * @returns
 */
export function useScheduleCoachPersonalDetailQuery({
  personalScheduleId,
  isAdmin = false
}: Params) {
  return useQuery(
    [queryKeys.PERSONAL_SCHEDULE, personalScheduleId, isAdmin],
    () =>
      isAdmin
        ? fetcher<ReservedPersonalSchedule>(
            `/gym-admins/coach-schedule/personal/${personalScheduleId}`
          )
        : fetcher<ReservedPersonalSchedule>(
            `/schedules/coach/personal/${personalScheduleId}`
          ),
    {
      enabled: !!personalScheduleId,
      cacheTime: 600000, // 10 minutes
      staleTime: 60000 // 1 minute
    }
  );
}
